import { render, staticRenderFns } from "./ProposalOverviewView.vue?vue&type=template&id=4b26a5ae&scoped=true&"
import script from "./ProposalOverviewView.vue?vue&type=script&lang=js&"
export * from "./ProposalOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalOverviewView.vue?vue&type=style&index=0&id=4b26a5ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26a5ae",
  null
  
)

export default component.exports